import { UserSettings } from 'src/types/UserSettings.ts';

export const buildLoadDatabaseUrl = (
    uri: string,
    userSettings: UserSettings,
) => `${uri}/export/${userSettings.currentRegion}/${userSettings.currentLocale}`;
